module.exports = __webpack_public_path__ + "static/media/img.75dd7fc2.svg";